import React, {useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useAuth } from '../../../hooks/useAuth';
import { getUser } from '../../../services/user-services';
import ProjectTabs from './answer-tabs';
import DialogUserInfo from './detail/dialog-user-info';
import SellStartNew from './sell-new';
import { getReqBuyDetail } from '../../../services/material-services';
import { Typography } from '@mui/material';
import { blue } from '@mui/material/colors';
import SellReqDoc from './doc/doc-req';

export default function DialogAnswer(props) {
    const { authData, authDataLang } = useAuth()
    const { onClose, selectedValue, open } = props
    // const [isAdmin, setIsAdmin] = useState(false)
    // const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)
    const [userClient, setUserClient] = useState(false)
    const [detailReqBuy, setDetailReqBuy] = React.useState(false)

    // const theme = useTheme()
    // const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

   
    const handleClose = () => {
        onClose(selectedValue)
    }

    useEffect(()=>{
        // if(authData?.user){
        //     setIsAdmin(authData.user?.profile?.is_permium)
        // }
        
        // console.log("selectedValue", selectedValue)
        setLoading(true)
        const getData = async() =>{
            await getReqBuyDetail(authData?.token, selectedValue?.id)
            .then(data => {
                // console.log("getReqBuyDetail", data)
                setDetailReqBuy(data)

                setLoading(false)
            }).catch( e => {
                // setError(true)
                setLoading(false)
            })
        }
        if(selectedValue?.user?.id){
            getData()
        }
    }, [authData, selectedValue])

    useEffect(()=>{
        
        setLoading(true)
        const getData = async() =>{
            await getUser(authData?.token, selectedValue?.user?.id)
            .then(data => {
                
                setUserClient(data?.user)

                setLoading(false)
            }).catch( e => {
                // setError(true)
                setLoading(false)
            })
        }
        if(selectedValue?.user?.id){
            getData()
        }
    }, [authData, selectedValue])
    
    // const handleListItemClick = (value) => {
    //     onClose(value)
    // }

    return (
        <React.Fragment>
            <Dialog
                    fullScreen={'md'}
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="responsive-dialog-title"
                    dir={authDataLang?.view_sts ? "rtl" : "ltr"}
                >
                <DialogTitle id="responsive-dialog-title">
                        <DialogUserInfo userClient={userClient} ReqUser={selectedValue}/>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                    <div>
                        <SellStartNew userClient={userClient} ReqUser={detailReqBuy}/>
                        <SellReqDoc userClient={userClient} ReqUser={detailReqBuy}/>
                        <ProjectTabs userClient={userClient} ReqUser={detailReqBuy}/>
                    </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleClose}>
                    <Typography 
                        fontFamily='b_mitra' 
                        component="div"
                        variant="h6"
                        color={blue[900]}
                        >
                        بستن
                    </Typography>
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

DialogAnswer.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    // selectedValue: PropTypes.string.isRequired,
}
  